export interface IconsRegistry {
  name: string;
  path: string;
}
